import { render } from "./IconBulletListItemDisabled.vue?vue&type=template&id=60d5e748"
const script = {}
script.render = render

export default script